import { render, staticRenderFns } from "./CreateContainerOptions.vue?vue&type=template&id=21e36af7&scoped=true"
import script from "./CreateContainerOptions.vue?vue&type=script&lang=js"
export * from "./CreateContainerOptions.vue?vue&type=script&lang=js"
import style0 from "./CreateContainerOptions.vue?vue&type=style&index=0&id=21e36af7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e36af7",
  null
  
)

export default component.exports